import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/product-management/_layout/suggested-activations")({
  beforeLoad: () => {
    throw redirect({
      to: "/product-management/inbox",
      replace: true,
    })
  },
})
